export default "__VITE_ASSET__DDzWsLxF__"